import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Badge, formatPrice } from '@retainerclub/common';
import PropTypes from 'prop-types';

function CurrentSubscriptionDetails({ subscription }) {
  function getStatusColor(status) {
    switch (status) {
      case 'active':
        return 'green';
      case 'inactive_no_card':
      case 'inactive_invalid_card':
        return 'yellow';
      case 'inactive_failed':
      case 'inactive_exceeded_failures':
        return 'red';
      case 'cancelled':
      case 'paused':
        return 'gray';
      default:
        return 'gray';
    }
  }

  return (
    <>
      {subscription?.renewalAt && (
        <p className="text-center">
          <span className="text-gray-700 text-sm">Next Renewal: </span>
          <span className="font-medium text-gray-900 text-sm">
            {subscription?.renewalAt
              ? new Date(subscription.renewalAt).toLocaleDateString()
              : 'N/A'}
          </span>
        </p>
      )}
      <div className="flex items-center justify-between rounded-lg border border-rcgray-300 bg-rcgray-50 p-4">
        <div className="flex items-center space-x-3">
          <CheckCircleIcon className="h-5 w-5" />
          <div>
            <h5 className="font-medium">
              {subscription.name}{' '}
              <span className="font-normal text-gray-500 text-sm">
                (current plan)
              </span>
            </h5>
            <p className="text-2xl text-gray-600">
              <span className="font-bold">
                {formatPrice(subscription.subscriptionPrice)}
              </span>{' '}
              <span className="text-gray-600 text-sm">/ year</span>
            </p>

            <ul className="mt-1 ml-2 list-inside list-disc text-gray-500 text-xs">
              {subscription.product.productFeatures
                .slice(0, 4)
                .map((feature) => (
                  <li key={feature.id}>{feature.text}</li>
                ))}
            </ul>
          </div>
        </div>
        <Badge
          name={
            subscription?.state.replace('inactive_', '').replace('_', ' ') ||
            'active'
          }
          color={getStatusColor(subscription?.state)}
          size="md"
        />
      </div>
    </>
  );
}

CurrentSubscriptionDetails.propTypes = {
  subscription: PropTypes.object.isRequired,
};

export default CurrentSubscriptionDetails;
